import CryptoJS from "crypto-js"
import decode from "jwt-decode";

export function getCurrentJwt() {
  try {
    let token = JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem("jwtToken"),process.env.REACT_APP_PASS).toString(CryptoJS.enc.Utf8))
    decode(token)
    return token
  }
  catch(_) {
    localStorage.clear()
    window.location.href = '/'
  }
  
}


// WEBPACK FOOTER //
// ./src/util/jwt/decryptToken.js